export default __webpack_public_path__ + "static/media/rocket_anim_14.e4cbb62c.png";